export default `float w = 1.0f;
  float t = 0.01f;
  return length(vec2(p.x * p.y * p.z, length(p) - w)) - t;
}`